module.exports = __webpack_public_path__ + "img/541.cee744c0.jpg";